// extracted by mini-css-extract-plugin
module.exports = {"UtilityBoxItem":"utility-box-item_UtilityBoxItem__S_jyx","childWrapper":"utility-box-item_childWrapper__czyIr","icon":"utility-box-item_icon__TdY5W"};